export class JointTexture { 
    public name: string;
    public textureKey: string;
    public swatchImageUrl: string;
    public isFlexibleJoint: boolean = false;
    public isRigidJoint: boolean = false;

    constructor({ textureKey, name, swatchImageUrl, isFlexibleJoint } : { textureKey: string, name?: string, swatchImageUrl?: string, isFlexibleJoint?: boolean }) {
        this.textureKey = textureKey;
        this.name = name;
        this.swatchImageUrl = swatchImageUrl;
        this.isFlexibleJoint = !!isFlexibleJoint;
        this.isRigidJoint = !isFlexibleJoint;
    }
}